import React from 'react';

interface MissionTabsProps {
  activeTab: 'goals' | 'badges';
  onTabChange: (tab: 'goals' | 'badges') => void;
}

const MissionTabs: React.FC<MissionTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex gap-6 border-b border-white/20 mb-6">
      <button
        onClick={() => onTabChange('goals')}
        className={`pb-3 text-xs sm:text-sm font-bold uppercase tracking-wider transition-all ${
          activeTab === 'goals'
            ? 'text-white border-b-2 border-white'
            : 'text-white/60 hover:text-white/80'
        }`}
      >
        Metas
      </button>
      <button
        onClick={() => onTabChange('badges')}
        className={`pb-3 text-xs sm:text-sm font-bold uppercase tracking-wider transition-all ${
          activeTab === 'badges'
            ? 'text-white border-b-2 border-white'
            : 'text-white/60 hover:text-white/80'
        }`}
        disabled
      >
        Conquistas
        <span className="ml-2 text-[10px] bg-white/20 px-2 py-0.5 rounded">Em breve</span>
      </button>
    </div>
  );
};

export default MissionTabs;
